const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();

if (!API_BASE_URL && process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.error('REACT_APP_API_BASE_URL is not set. Set it in your environment for production.');
}

export { API_BASE_URL };









